import { apiAddress } from "../../config/server";
import { IPerson } from "../../types/persons/person";
import { IToken } from "../../types/token/Token";
import { ApiBase } from "./baseApi";

export default class TokenApi extends ApiBase {
  static TokenApiAddress = `${apiAddress}/api/token/`;

  static GetTokenAddress = (tokenId, type) =>
    `${TokenApi.TokenApiAddress}${tokenId}/${type}`;

  static getToken(
    tokenId: string,
    type,
  ): Promise<{ token: IToken; person: IPerson }> {
    const address = this.GetTokenAddress(tokenId, type);
    return TokenApi.get<{ token: IToken; person: IPerson }>(address).then(
      (response) => response.data.data,
    );
  }
}
